var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallWhiteCta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_965_28565)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 9,
    width: 44,
    height: 44,
    rx: 22,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7232 40.1484L40.8191 32.4704C40.9483 32.3243 41.0496 32.1521 41.1172 31.9636C41.2591 31.5897 41.2591 31.1704 41.1172 30.7965C41.0496 30.608 40.9483 30.4358 40.8191 30.2898L33.7232 22.6118C33.5908 22.4686 33.4338 22.355 33.2609 22.2775C33.088 22.2 32.9027 22.1602 32.7155 22.1602C32.3376 22.1602 31.9751 22.3226 31.7079 22.6118C31.4407 22.9009 31.2905 23.2931 31.2905 23.702C31.2905 24.111 31.4407 24.5032 31.7079 24.7923L36.3913 29.8445L24.2004 29.8445C23.824 29.8445 23.463 30.0063 23.1968 30.2942C22.9307 30.5822 22.7812 30.9728 22.7812 31.3801C22.7812 31.7873 22.9307 32.1779 23.1968 32.4659C23.463 32.7539 23.824 32.9157 24.2004 32.9157L36.3913 32.9157L31.7079 37.9678C31.5749 38.1106 31.4693 38.2804 31.3973 38.4675C31.3252 38.6547 31.2881 38.8554 31.2881 39.0581C31.2881 39.2608 31.3252 39.4615 31.3973 39.6487C31.4693 39.8358 31.5749 40.0056 31.7079 40.1484C31.8398 40.2923 31.9968 40.4066 32.1697 40.4845C32.3427 40.5625 32.5282 40.6026 32.7155 40.6026C32.9029 40.6026 33.0884 40.5625 33.2613 40.4845C33.4343 40.4066 33.5912 40.2923 33.7232 40.1484Z",
    fill: "#1865C1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_965_28565",
    x: 0,
    y: 0,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_965_28565"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_965_28565",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallWhiteCta);
export default __webpack_public_path__ + "static/media/small_white_cta.7bb8a959d9ef0a97f517d6a34be18211.svg";
export { ForwardRef as ReactComponent };